import SchedulerSinglePageUnscaledExporter from '../../../../Scheduler/feature/export/exporter/SinglePageUnscaledExporter.js';
import GanttExporterMixin from './GanttExporterMixin.js';

/**
 * @module Gantt/feature/export/exporter/SinglePageUnscaledExporter
 */

/**
 * A single page exporter. Used by the {@link Gantt.feature.export.PdfExport} feature to export to single page. Content
 * is exported with dimensions required to fit all requested rows and columns. This allows generating PDF page not
 * constrained by the standard paper formats.
 *
 * You do not need to use this class directly.
 *
 * ### Extending exporter
 *
 * ```javascript
 * class MySinglePageExporter extends SinglePageUnscaledExporter {
 *     // type is required for exporter
 *     static get type() {
 *         return 'mysinglepageexporter';
 *     }
 *
 *     get stylesheets() {
 *         const stylesheets = super.stylesheets;
 *
 *         stylesheets.forEach(styleNodeOrLinkTag => doSmth(styleNodeOrLinkTag))
 *
 *         return stylesheets;
 *     }
 * }
 *
 * const gantt = new Gantt({
 *     features : {
 *         pdfExport : {
 *             // this export feature is configured with only one exporter
 *             exporters : [MySinglePageExporter]
 *         }
 *     }
 * });
 *
 * // run export with the new exporter
 * gantt.features.pdfExport.export({ exporter : 'mysinglepageexporter' });
 * ```
 *
 * @classtype singlepageunscaled
 * @extends Scheduler/feature/export/exporter/SinglePageUnscaledExporter
 *
 * @typings Scheduler.feature.export.exporter.SinglePageUnscaledExporter -> Scheduler.feature.export.exporter.SchedulerSinglePageUnscaledExporter
 */
export default class SinglePageUnscaledExporter extends GanttExporterMixin(SchedulerSinglePageUnscaledExporter) {

    static $name = 'SinglePageUnscaledExporter';

    static type = 'singlepageunscaled';
}
